import useTranslation from 'next-translate/useTranslation'
import { useSession } from 'next-auth/react'
import styles from './AtsIntegrationTable.module.scss'
import CheckboxItem from '../../molecules/Pricing/CheckboxItem'

const AtsIntegrationTable = () => {
  const { data: session } = useSession()
  const { t } = useTranslation('pricing')

  const getUrl = (product: string) => {
    if (session?.accessToken?.includes('user')) {
      return `/dashboard/payments/new?${product}=1`
    }
    return `/auth/choose?target=${encodeURIComponent(
      `/dashboard/payments/new?${product}=1`
    )}`
  }

  return (
    <div className={styles['ats-integration-table']}>
      <div className={`${styles['ats-integration-table__description']}`}>
        <h2>{t('atsTitle')}</h2>
        <div className='mt-8'>
          <CheckboxItem
            itemKey='pricing:atsPoint1'
            components={[<b className='font-bold' />]}
            color='text-raspberry-600'
          />

          <CheckboxItem
            itemKey='pricing:atsPoint2'
            color='text-raspberry-600'
          />
          <CheckboxItem
            itemKey='pricing:atsPoint3'
            color='text-raspberry-600'
          />
          <CheckboxItem
            itemKey='pricing:atsPoint4'
            color='text-raspberry-600'
            components={[<b className='font-bold' />]}
            explanationKey='atsPoint4Explain'
          />
          <CheckboxItem
            itemKey='pricing:atsPoint5'
            color='text-raspberry-600'
          />
        </div>
      </div>

      <div className='flex items-center justify-center'>
        <div>
          {/* <div className='my-6'>
          <div className='text-center'>{t('atsMonthly')}</div>
          <div
            className={`${styles['ats-integration-table__price']} text-center`}
          >
            {t('atsPriceMonthly')}
          </div>
          <div
            className={`${styles['ats-integration-table__price-subtext']} text-center`}
          >
            {t('atsPriceMonthlySub')}
          </div>
        </div>
        <hr className='h-px my-8 bg-gray-200 border-0 dark:bg-gray-700' />
        <div className='my-6'>
          <div className='text-center'>{t('atsYearly')}</div>
          <div
            className={`${styles['ats-integration-table__price']} text-center`}
          >
            {t('atsPriceYearly')}
          </div>
          <div
            className={`${styles['ats-integration-table__price-subtext']} text-center`}
          >
            {t('atsPriceYearlySub')}
          </div>
          <div className='text-center text-raspberry-600'>
            {t('atsPriceYearlySave')}
          </div>
        </div> */}

          <div className='text-center mb-6'>{t('atsCta')}</div>
          <button
            type='button'
            onClick={() => {
              const message = document.querySelector(
                '#contact-form input[name=message]'
              )
              if (message) (message as HTMLInputElement).value = t('atsMessage')
              document.getElementById('contact-form')?.scrollIntoView({
                behavior: 'smooth',
              })
            }}
            className=' bg-raspberry-600 text-white w-full px-6 py-4 text-lg rounded-full inline-block text-center text-xl font-thin duration-300 hover:bg-raspberry-500'
          >
            {t('needMoreContact')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AtsIntegrationTable
